import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import AdministrationSidebar from 'src/features/administration/components/AdministrationSidebar';
import { Dialog, DialogContent } from 'src/registry/ui/Dialog';

function AdministrationLayout() {

    return (
        <div className="relative">
            <Dialog modal={false} open>
                <DialogContent variant="leftSheetStatic" showCloseButton={false} className="overflow-y-auto">
                    <AdministrationSidebar />
                </DialogContent>
            </Dialog>
            <MainLayout>
                <Outlet />
            </MainLayout>
        </div>
    );
}

export default AdministrationLayout;
